function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.836 24.363l-.191-.117-.226-.156-.142-.109-.085-.07-.402-.37-.059-.062L20 20.955l-.002.002-1.033-.958-3.1-2.865a3.338 3.338 0 00-2.052-.705c-1.898 0-3.437 1.599-3.437 3.571 0 1.972 1.539 3.571 3.438 3.571.767 0 1.476-.261 2.048-.703l2.084-1.927 1.041.95-1.717 1.588c-.112.12-.23.235-.355.344l-.19.158-.166.125-.203.14-.19.117-.056.032-.215.114-.246.114a4.635 4.635 0 01-1.835.377C11.155 25 9 22.761 9 20s2.155-5 4.813-5c.898 0 1.74.256 2.459.701l.251.167.191.142.019.015c.19.15.368.316.533.493L20 19.043l.005-.005 1.032.959-.002.002.703.649 1.686 1.566.004-.006.715.661.062.048c.56.412 1.245.654 1.983.654 1.899 0 3.438-1.599 3.438-3.571 0-1.972-1.539-3.571-3.438-3.571-.768 0-1.478.262-2.05.705l-2.079 1.918-1.034-.956 1.71-1.578c.11-.118.226-.23.348-.337l.204-.171.23-.17a4.664 4.664 0 012.672-.84C28.845 15 31 17.239 31 20s-2.155 5-4.813 5a4.643 4.643 0 01-1.59-.28l-.27-.107-.226-.106-.265-.144z",
  fill: "#222",
  fillRule: "evenodd"
});

var SvgInfinity = function SvgInfinity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfinity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Infinity.fce2b350.svg";
export { ForwardRef as ReactComponent };